import React from "react";
import { Card, CardBody, Nav, NavItem, NavLink, TabContent, TabPane, Row, Col } from "reactstrap";
import { toast } from "react-toastify";
import Pagination from "../components/common/pagination";
import StoresInSimulationTable from "../components/StoresInSimulationTable";
import CamerasInSimulationTable from "../components/CamerasInSimulationTable";
import { getStoresInSimulation } from "../services/storeService";
import { getCamerasInSimulation } from "../components/cameraPrototypes/shared/captureDeviceService";
import * as Sentry from "@sentry/react";

class StoresInSimulationView extends React.Component {
  state = {
    activeTab: "stores-tab",
    stores: [],
    cameras: [],
    storesCurrentPage: 1,
    camerasCurrentPage: 1,
    storesCount: 0,
    camerasCount: 0,
    pageSize: 20,
  };

  async componentDidMount() {
    await this.fetchStores();
  }

  async componentDidUpdate(prevProps, prevState) {
    const { storesCurrentPage, camerasCurrentPage, activeTab, cameras } = this.state;
    if (prevState.storesCurrentPage !== storesCurrentPage) {
      await this.fetchStores();
    }
    if (prevState.camerasCurrentPage !== camerasCurrentPage) {
      await this.fetchCameras();
    }
    // Fetch cameras when switching to cameras tab if not already loaded
    if (prevState.activeTab !== activeTab && activeTab === "cameras-tab" && cameras.length === 0) {
      await this.fetchCameras();
    }
  }

  fetchStores = async () => {
    const { storesCurrentPage, pageSize } = this.state;
    try {
      const { data: pagedStores } = await getStoresInSimulation(storesCurrentPage, pageSize);
      const stores = pagedStores.results || [];
      const count = pagedStores.count || 0;

      this.setState({ stores, storesCount: count });
    } catch (ex) {
      console.log(ex);
      toast.error("Failed to fetch stores in simulation");
    }
  };

  fetchCameras = async () => {
    const { camerasCurrentPage, pageSize } = this.state;
    try {
      const { results: cameras, count } = await getCamerasInSimulation(camerasCurrentPage, pageSize);

      this.setState({ cameras, camerasCount: count });
    } catch (ex) {
      console.log(ex);
      toast.error("Failed to fetch cameras in simulation");
    }
  };

  handleStoresPageChange = (page) => {
    this.setState({ storesCurrentPage: page });
  };

  handleCamerasPageChange = (page) => {
    this.setState({ camerasCurrentPage: page });
  };

  selectTab = (tabId) => {
    this.setState({ activeTab: tabId });
  };

  render() {
    const { activeTab, stores, cameras, storesCount, camerasCount, pageSize, storesCurrentPage, camerasCurrentPage } =
      this.state;
    return (
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardBody style={{ padding: 0 }}>
                <Nav tabs style={{ marginBottom: 0, borderBottom: "1px solid #dee2e6" }}>
                  <NavItem>
                    <NavLink
                      className={activeTab === "stores-tab" ? "active" : ""}
                      onClick={() => {
                        this.selectTab("stores-tab");
                      }}
                    >
                      <p>Stores</p>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={activeTab === "cameras-tab" ? "active" : ""}
                      onClick={() => {
                        this.selectTab("cameras-tab");
                      }}
                    >
                      <p>Cameras</p>
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={activeTab} style={{ padding: "1.25rem" }}>
                  <TabPane tabId="stores-tab">
                    <StoresInSimulationTable stores={stores} />
                    <Pagination
                      itemsCount={storesCount}
                      pageSize={pageSize}
                      currentPage={storesCurrentPage}
                      onPageChange={this.handleStoresPageChange}
                      label="stores"
                    />
                  </TabPane>
                  <TabPane tabId="cameras-tab">
                    <CamerasInSimulationTable cameras={cameras} />
                    <Pagination
                      itemsCount={camerasCount}
                      pageSize={pageSize}
                      currentPage={camerasCurrentPage}
                      onPageChange={this.handleCamerasPageChange}
                      label="cameras"
                    />
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Sentry.withProfiler(StoresInSimulationView);
